if (!window.customElements.get('saved-protocols')) {
  class SavedProtocols extends HTMLElement {

    constructor() {
      super()
      this.protocolsContainer = this
      this.protocolsList = this.querySelector('[data-saved-protocols-list]')
      this.protocolsListEmptyMessage = this.querySelector('[data-saved-protocols-list-empty-message]')
      this.protocols = this.querySelector('[data-saved-protocol-container]')
      this.protocolsSearch = this.querySelector('[data-saved-protocols-search]')
      this.protocolsWrapper = this.querySelector('[data-saved-protocols-wrapper]')
      this.protocolsLoadingMessage = this.querySelector('[data-saved-protocols-loading]')
      this.allOtherSections = document.querySelectorAll('[data-account-dashboard-container] .shopify-section:not(.shopify-section--saved-protocols)');
    }

    connectedCallback() {
      this.initSavedProtocols();

      document.body.addEventListener('click', async (event) => {
        if (!event.target.hasAttribute('data-saved-protocol-list-item-edit')) { return; }

        event.preventDefault();

        const protocol = event.target.closest('[data-saved-protocol]')
        const products = protocol.querySelectorAll('[data-saved-protocol-product]')
        const editButtonLink = protocol.querySelector('[data-saved-protocol-list-item-edit]')

        const productData = Array.from(products).map((product) => {
          return {
            title: product.getAttribute('data-product-title'),
            handle: product.getAttribute('data-product-handle'),
            variantId: product.getAttribute('data-variant-id')
          }
        });

        const soldoutItems = await window.checkInventoryLevels(productData, editButtonLink)

        if (!soldoutItems) {
          window.location.href = event.target.getAttribute('href')
        }
      });
    }

    initSavedProtocols() {
      if(!this.hasAttribute("data-no-swyncallbacks"))
      {
        if (!window.SwymCallbacks) { window.SwymCallbacks = [] }

        window.SwymCallbacks.push(this.onSwymLoadCallback.bind(this));
      }
      
      
      this.addEventListener('click', (event) => {
        this.handleEvents(event)

        if (event.target.hasAttribute('data-show-all-button')) {
          this.classList.toggle('active');
          const items = this.querySelectorAll(event.target.getAttribute('data-target-attribute'));

          items.forEach((item, index) => {
            if (this.classList.contains('active')) {
              item.classList.remove('hidden');
            } else {
              item.classList.toggle('hidden', index > 2);
            }
          });
        }
      })

      document.addEventListener('change', (event) => {
        this.adjustQuantity(event)
      })
    }

    onSwymLoadCallback(swat) {
      if (swat) {
        swat.fetchLists({
          callbackFn: this.buildLists.bind(this),
        })
      } else {
        window.location.reload();
      }
    }

    handleEvents(event) {
      this.backToProtocols(event)
      this.showProtocol(event)
      this.openDeleteProtocolModal(event)
      this.openRenameProtocolModal(event)
      this.closeProtocolModal(event)
      this.deleteProtocol(event)
      this.renameProtocol(event)
      this.removeProduct(event)
      this.addToCart(event)
    }

    buildLists(lists) {
      if (lists.length) {

        let listsArray = lists;

        if (this.hasAttribute('data-email-address')) {
          const emailAddress = this.getAttribute('data-email-address');
          listsArray = lists.filter((list) => list.lprops?.['Email Address'] === emailAddress);
        } else if (!this.hasAttribute('data-show-all-protocols')) {
          listsArray = [];
        }

        if (listsArray.length === 0) {
          this.protocolsWrapper.classList.remove('hide')
          this.protocolsLoadingMessage.classList.add('hide')
        } else {
          if (this.protocolsListEmptyMessage) {
            this.protocolsListEmptyMessage.classList.add('hidden');
          }

          listsArray.forEach((list, index) => {
            if (list.listcontents.length) {
              this.buildProtocolListItem(list, index)
              this.buildProtocolProductList(list)
              this.buildProtocolDeleteModal(list)
              this.buildProtocolRenameModal(list)
            } else {
              this.deleteEmptyList(list)
            }
          })

          if (this.hasAttribute('data-truncate') && listsArray.length > 3) {
            this.buildShowAllUi(listsArray);
          }
        }
      }
    }

    buildShowAllUi(listsArray) {
      const listItem = document.createElement('li')

      listItem.innerHTML = `
        <div class="flex justify-between text-xs">
          <span class="disabled-text">
            ${window.protocolsData.language.displaying} 3 ${window.protocolsData.language.of} ${listsArray.length}
          </span>

          <span class="active-text">
            ${window.protocolsData.language.displaying} ${listsArray.length} ${window.protocolsData.language.of} ${listsArray.length}
          </span>

          <button class="saved-protocols__show-all flex align-center"
            data-target-attribute="[data-saved-protocols-list-item-wrapper]"
            data-show-all-button
          >
            <span class="disabled-text">
              ${window.protocolsData.language.showAll}
            </span>

            <span class="active-text">
              ${window.protocolsData.language.showLess}
            </span>

            <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1.5L5 5.5L9 1.5" stroke="#1A1A1A" stroke-width="2"/>
            </svg>
          </button>
        </div>
      `;

      this.protocolsList.appendChild(listItem);
    }

    buildProtocolListItem(list, index) {
      const listItem = document.createElement('li')
      const listTotalPrice = list.listcontents.map(item => (item.pr * (item.qty === undefined ? 1 : item.qty))).reduce((a, b) => a + b, 0).toFixed(2)

      listItem.setAttribute('data-saved-protocols-list-item-wrapper', '')
      listItem.setAttribute('data-search-item', '')
      listItem.setAttribute('data-search-attribute', `${list.lname} ${list.hasOwnProperty('lprops') ? list.lprops["Client Name"] : ''}` )
      listItem.classList.add('saved-protocols-list-item')

      if (this.hasAttribute('data-truncate') && index >= 3) {
        listItem.classList.add('hidden')
      }

      listItem.innerHTML = `
        <button class="saved-protocols-list-item__button" type="button" aria-label="Show ${list.lname} products" data-lid="${list.lid}" data-saved-protocols-list-item>
          <div class="saved-protocols-list-item__content">
            <strong class="saved-protocols-list-item__title">${list.lname}</strong>
            ${list.hasOwnProperty('lprops') ?
              `<span class="saved-protocols-list-item__client">${list.lprops["Client Name"]}</span>`
              : ''
            }
            <span class="saved-protocols-list-item__total" data-total-lid="${list.lid}" data-saved-protocol-total="${listTotalPrice}">${window.protocolsData.language.total}: ${Shopify.formatMoney(listTotalPrice, window.themeVariables.settings.moneyFormat)}</span>
          </div>

          <span class="saved-protocols-list-item__cta button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_769_11814)">
                <path d="M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z" fill="white" stroke="#0D4E57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z" stroke="#0D4E57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_769_11814">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>

            ${window.protocolsData.language.view}
          </span>
        </button>
      `

      this.protocolsList.appendChild(listItem)
    }

    buildProtocolProductList(list) {
      const protocol = document.createElement('div')

      protocol.setAttribute('data-lid', list.lid)
      protocol.setAttribute('data-saved-protocol', '')
      protocol.classList.add('hide')

      const listTotalPrice = list.listcontents.map(item => (item.pr * (item.qty === undefined ? 1 : item.qty))).reduce((a, b) => a + b, 0).toFixed(2)

      // Protocol Header
      const protocolHeader = document.createElement('div')
      protocolHeader.classList.add('saved-protocols__protocol-header')

      const listBaseIngredients = (list.lprops) ? list.lprops['Base Ingredients'] : "";

      const protocolClientInfo = document.createElement('ul')

      if (list.hasOwnProperty('lprops')) {
        for (const [key, value] of Object.entries(list.lprops)) {
          if(key !== 'Base Ingredients'){
            const protocolClientLineItem = document.createElement('li')
            const keyAttribute = (key === 'Label Name') ? 'data-saved-protocol-line-property-key' : 'data-saved-protocol-cart-attribute-key'
            const valueAttribute = (key === 'Label Name') ? 'data-saved-protocol-line-property-value' : 'data-saved-protocol-cart-attribute-value'

            protocolClientLineItem.setAttribute(keyAttribute, key)
            protocolClientLineItem.setAttribute(valueAttribute, value)

            protocolClientLineItem.innerHTML = `
              <span>${key}:</span>
              <span>${value}</span>
            `

            protocolClientInfo.appendChild(protocolClientLineItem)
          }
        }
      }

      protocolHeader.innerHTML = `
        <button class="saved-protocols__back" type="button" data-back-to-saved-protocols>
          <
          <span class="link">
            ${window.protocolsData.language.backToProtocols}
          </span>
        </button>

        <h2 class="saved-protocols__protocol-title">${list.lname}</h2>
        <div class="saved-protocols__protocol-header-actions">
          <button class="saved-protocols__protocol-header-action button" type="button" data-saved-protocol-add-to-cart>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_825_3791)">
                <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
                <path d="M8.25 12H15.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 8.25V15.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_825_3791">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <span>${window.protocolsData.language.addProductsToCart}</span>
          </button>
        </div>

        <div class="saved-protocols__protocol-client">
          <h3>${window.protocolsData.language.clientHeading}</h3>
          ${protocolClientInfo.outerHTML}
        </div>
      `

      protocol.appendChild(protocolHeader)

      // Protocol Summary
      const protocolSummary = document.createElement('div')
      protocolSummary.classList.add('saved-protocols__protocol-summary')

      protocolSummary.innerHTML = `
        <div class="saved-protocols__protocol-summary-title">
          <h3>${window.protocolsData.language.protocolHeading}</h3>
        </div>
      `

      const productTypes = ['main', 'flavour', 'addon', 'binder', 'retail']
      const filteredProducts = productTypes.reduce((acc, type) => {
        acc[type] = list.listcontents.filter(item => item.cprops?.type === type)
        return acc
      }, {})

      const mainProduct = filteredProducts.main
      const flavourProducts = filteredProducts.flavour
      const addonProducts = filteredProducts.addon
      const binderProducts = filteredProducts.binder
      const retailProducts = filteredProducts.retail
      let additionalProductsHeading = false;

      function createProductListElement(products, heading, type) {
        const listEl = document.createElement('ul')
        listEl.classList.add('saved-protocols__protocol-category', `saved-protocols__protocol-category--${type}`)
        listEl.setAttribute('data-saved-protocols-category', type)

        if (heading) {
          listEl.innerHTML = `<li><h4>${heading}</h4></li>`
        } else if (!additionalProductsHeading) {
          additionalProductsHeading = true;
          listEl.innerHTML = `<li data-additional-products-heading><h4>${window.protocolsData.language.additionalProductsHeading}</h4></li>`
        }

        products.forEach(item => {
          const product = document.createElement('li')
          const variant = (item.vi === undefined) ? null : item.vi.includes('/') ? item.vi.split('/').slice(1).join('/') : item.vi
          product.classList.add('saved-protocol-list-item', `saved-protocol-list-item--${type}`)
          product.setAttribute('data-saved-protocol-product', '')
          product.setAttribute('data-variant-id', item.epi)
          product.setAttribute('data-product-handle', item.du.split('/products/')[1].split('?')[0])
          product.setAttribute('data-product-title', `${item.dt} - ${variant}`)
          product.setAttribute('data-product-type', item.cprops?.type)

          let productActions
          if (type === 'retail' && !mainProduct.length) {
            productActions = document.createElement('span')
            productActions.classList.add('saved-protocol-list-item__actions')
            productActions.innerHTML = `
              <button class="saved-protocol-list-item__remove link text-xs text-subdued" type="button" aria-label="Remove ${item.dt}" data-lid="${list.lid}" data-epi="${item.epi}" data-empi="${item.empi}" data-du="${item.du}" data-saved-protocol-product-remove>
                ${window.protocolsData.language.remove}
              </button>

              <input class="saved-protocol-list-item__quantity quantity-input text-center" type="number" value="${item.qty === undefined ? 1 : item.qty}" min="1" id="qty--${item.uid}" data-saved-protocol-quantity data-lid="${list.lid}" data-epi="${item.epi}" data-empi="${item.empi}" data-du="${item.du}" data-price="${item.pr}">
            `
          }

          product.innerHTML = `
            <div class="saved-protocol-list-item__content">
              <span class="saved-protocol-list-item__product-title">
                ${item.qty === undefined || (item.qty === 1 && type !== 'retail') ? '<span class="hide" data-saved-product-quantity-display></span>' : `<span data-saved-product-quantity-display>${item.qty}x</span>`}
                <span>${item.dt}${variant === null ? '' : ` - ${variant}`}</span>
                ${(type === 'retail' && !mainProduct.length) ? productActions.outerHTML : ''}
                ${item.qty === undefined || (item.qty === 1 && type !== 'retail') ? '' : `<input type="hidden" value="${item.qty === undefined ? 1 : item.qty}" data-saved-protocol-quantity>`}
              </span>

              <span class="saved-protocol-list-item__price text-subdued bold" data-saved-protocol-product-price>${item.pr > 0 ? Shopify.formatMoney((item.pr * (item.qty === undefined ? 1 : item.qty) * 100), window.themeVariables.settings.moneyFormat).replace('.00', '') : '-'}</span>
            </div>
          `

          listEl.appendChild(product)
        })

        return listEl
      }

      function appendProductList(productType, productArray, heading) {
        if (!productArray.length) { return }
        const productListEl = createProductListElement(productArray, heading, productType)
        protocolSummary.appendChild(productListEl)
      }

      // Main product
      const mainProductEl = document.createElement('ul')
      mainProductEl.classList.add('saved-protocols__protocol-category')

      for (const item of mainProduct) {
        const product = document.createElement('li')
        const variant = (item.vi === undefined) ? null : item.vi.includes('/') ? item.vi.split('/')[1] : item.vi
        product.classList.add('saved-protocol-list-item', 'saved-protocol-list-item--main')
        product.setAttribute('data-saved-protocol-product', '')
        product.setAttribute('data-variant-id', item.epi)
        product.setAttribute('data-product-handle', item.du.split('/products/')[1].split("?")[0])
        product.setAttribute('data-product-title', `${item.dt} - ${variant}`)
        product.setAttribute('data-product-type', item.cprops?.type)
        product.setAttribute('data-sku',item.sku)

        const variantList = document.createElement('ul')
        variantList.classList.add('saved-protocol-list-item__variant')

        item.vi.split('/').forEach((option, i) => {
          variantList.innerHTML += `
            <li>
              <div class="saved-protocol-list-item__content">
                <span>${option}</span>
                <span class="saved-protocol-list-item__price bold text-subdued" data-saved-protocol-product-price>${i === 0 ? Shopify.formatMoney((item.pr * 100), window.themeVariables.settings.moneyFormat).replace('.00', '') : '-'}</span>
              </div>
            </li>`
        })

        product.innerHTML = `
          <h4>${item.dt}</h4>
          ${variantList.outerHTML}
          ${
            (listBaseIngredients)?
            `
            <div class="ingredients-dropdown" onclick="openIngredientsDropdown(this);">
              <div class="ingredients-dropdown-label">
                <span class="text-xs opacity-7">View Base Ingredients</span>
                <span class="arrow-icon">
                  <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                    <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
                  </svg>
                </span>
              </div>
              <div class="ingredients-dropdown-list" style="display:none;">
                ${listBaseIngredients}
              </div>
            </div>

            `
            :""
          }
        `

        mainProductEl.appendChild(product)
      }

      protocolSummary.appendChild(mainProductEl)

      // Addon products
      appendProductList('addon', addonProducts, window.protocolsData.language.addonsHeading)

      // Flavour products
      appendProductList('flavour', flavourProducts)

      // Binder products
      appendProductList('binder', binderProducts)

      // Retail products
      appendProductList('retail', retailProducts)

      const protocolSummaryFooter = document.createElement('div')
      protocolSummaryFooter.classList.add('saved-protocols__protocol-summary-footer')
      protocolSummaryFooter.innerHTML = `
        <h4>${window.protocolsData.language.protocolTotal}</h4>
        <p class="bold" data-total-lid="${list.lid}" data-saved-protocol-total="${listTotalPrice}">${Shopify.formatMoney(listTotalPrice, window.themeVariables.settings.moneyFormat)}</p>
      `

      protocolSummary.appendChild(protocolSummaryFooter)
      protocol.appendChild(protocolSummary)

      // Protocol Actions
      const protocolActions = document.createElement('ul')
      protocolActions.classList.add('saved-protocols__protocol-actions')

      protocolActions.innerHTML = `
        ${mainProduct.length ?
          `<li>
            <a href="${mainProduct[0].du.split('?')[0]}?edit_lid=${mainProduct[0].lid}&view=configurator" class="saved-protocols__protocol-action button button--outline" title="${window.protocolsData.language.edit}: ${list.lname}" aria-label="${window.protocolsData.language.edit}: ${list.lname}" data-saved-protocol-list-item-edit="${list.lid}">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_825_2513)">
                  <path d="M12 16.25C14.0711 16.25 15.75 14.5711 15.75 12.5C15.75 10.4289 14.0711 8.75 12 8.75C9.92893 8.75 8.25 10.4289 8.25 12.5C8.25 14.5711 9.92893 16.25 12 16.25Z" stroke="#0D4E57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3.88352 17.1959C3.46912 16.4821 3.15164 15.7163 2.93945 14.9187L4.51258 12.9499C4.49477 12.649 4.49477 12.3472 4.51258 12.0462L2.94039 10.0774C3.15221 9.2797 3.46904 8.51363 3.88258 7.79932L6.38664 7.51807C6.5866 7.29278 6.79979 7.07959 7.02508 6.87963L7.30633 4.3765C8.01961 3.96494 8.78443 3.64999 9.5807 3.43994L11.5495 5.01307C11.8504 4.99525 12.1522 4.99525 12.4532 5.01307L14.422 3.44088C15.2197 3.6527 15.9858 3.96953 16.7001 4.38307L16.9813 6.88713C17.2066 7.08709 17.4198 7.30028 17.6198 7.52557L20.1229 7.80682C20.5373 8.5206 20.8548 9.28639 21.067 10.084L19.4938 12.0528C19.5116 12.3537 19.5116 12.6555 19.4938 12.9565L21.066 14.9253C20.8557 15.7228 20.5404 16.4888 20.1285 17.2034L17.6245 17.4846C17.4245 17.7099 17.2113 17.9231 16.986 18.1231L16.7048 20.6262C15.991 21.0406 15.2252 21.3581 14.4276 21.5703L12.4588 19.9971C12.1578 20.0149 11.8561 20.0149 11.5551 19.9971L9.58633 21.5693C8.78882 21.359 8.02276 21.0437 7.3082 20.6318L7.02695 18.1278C6.80167 17.9278 6.58848 17.7146 6.38852 17.4893L3.88352 17.1959Z" stroke="#0D4E57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_825_2513">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                  </clipPath>
                </defs>
              </svg>
              <span>${window.protocolsData.language.edit}</span>
            </a>
          </li>`
          : ''
        }
        <li>
          <button class="saved-protocols__protocol-action button button--outline" type="button" aria-label="${window.protocolsData.language.rename}: ${list.lname}" data-saved-protocol-list-item-rename="${list.lid}">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_825_1285)">
                <path d="M21 12.5001V20.0001C21 20.3979 20.842 20.7795 20.5607 21.0608C20.2794 21.3421 19.8978 21.5001 19.5 21.5001H4.5C4.10218 21.5001 3.72064 21.3421 3.43934 21.0608C3.15804 20.7795 3 20.3979 3 20.0001V5.0001C3 4.60228 3.15804 4.22075 3.43934 3.93944C3.72064 3.65814 4.10218 3.5001 4.5 3.5001H12C12.1989 3.5001 12.3897 3.57912 12.5303 3.71977C12.671 3.86042 12.75 4.05119 12.75 4.2501C12.75 4.44901 12.671 4.63978 12.5303 4.78043C12.3897 4.92108 12.1989 5.0001 12 5.0001H4.5V20.0001H19.5V12.5001C19.5 12.3012 19.579 12.1104 19.7197 11.9698C19.8603 11.8291 20.0511 11.7501 20.25 11.7501C20.4489 11.7501 20.6397 11.8291 20.7803 11.9698C20.921 12.1104 21 12.3012 21 12.5001ZM21.5306 7.03073L12.5306 16.0307C12.4609 16.1004 12.3782 16.1556 12.2871 16.1932C12.1961 16.2308 12.0985 16.2502 12 16.2501H9C8.80109 16.2501 8.61032 16.1711 8.46967 16.0304C8.32902 15.8898 8.25 15.699 8.25 15.5001V12.5001C8.24992 12.4016 8.26926 12.304 8.3069 12.213C8.34454 12.1219 8.39975 12.0392 8.46937 11.9695L17.4694 2.96948C17.539 2.89974 17.6217 2.84442 17.7128 2.80668C17.8038 2.76894 17.9014 2.74951 18 2.74951C18.0986 2.74951 18.1962 2.76894 18.2872 2.80668C18.3783 2.84442 18.461 2.89974 18.5306 2.96948L21.5306 5.96948C21.6004 6.03913 21.6557 6.12185 21.6934 6.2129C21.7312 6.30395 21.7506 6.40154 21.7506 6.5001C21.7506 6.59866 21.7312 6.69626 21.6934 6.78731C21.6557 6.87836 21.6004 6.96107 21.5306 7.03073ZM19.9369 6.5001L18 4.56041L16.8103 5.7501L18.75 7.68979L19.9369 6.5001Z" fill="#0D4E57"/>
              </g>
              <defs>
                <clipPath id="clip0_825_1285">
                  <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
              </defs>
            </svg>
            <span>${window.protocolsData.language.rename}</span>
          </button>
        </li>
        <li>
          <button class="saved-protocols__protocol-action button button--outline" type="button" onClick="generateProtocolSummaryNew(this);" data-saved-protocol-print>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_825_11)">
                <path d="M19.1036 21.1035L19.7635 21.7635L19.1036 21.1036C19.0098 21.1973 18.8826 21.25 18.75 21.25H5.25C5.11739 21.25 4.99022 21.1973 4.89645 21.1036C4.80268 21.0098 4.75 20.8826 4.75 20.75V4.25C4.75 4.11739 4.80268 3.99021 4.89645 3.89645C4.99021 3.80268 5.11739 3.75 5.25 3.75H13.7658C13.4501 3.92456 13.25 4.25842 13.25 4.625V8.75C13.25 9.30228 13.6977 9.75 14.25 9.75H18.375C18.7416 9.75 19.0754 9.54986 19.25 9.23417V20.75C19.25 20.8826 19.1973 21.0098 19.1036 21.1035Z" stroke="#0D4E57" stroke-width="2" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_825_11">
                  <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
              </defs>
            </svg>
            <span>${window.protocolsData.language.generatePdfQuote}</span>
          </button>
        </li>
        <li>
          <button class="saved-protocols__protocol-action button button--outline" type="button" aria-label="${window.protocolsData.language.delete}: ${list.lname}" data-saved-protocol-list-item-delete="${list.lid}">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_825_9320)">
                <path d="M15 9.5L9 15.5" stroke="#0D4E57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 9.5L15 15.5" stroke="#0D4E57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 21.5C16.9706 21.5 21 17.4706 21 12.5C21 7.52944 16.9706 3.5 12 3.5C7.02944 3.5 3 7.52944 3 12.5C3 17.4706 7.02944 21.5 12 21.5Z" stroke="#0D4E57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_825_9320">
                  <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
              </defs>
            </svg>
            <span>${window.protocolsData.language.delete}</span>
          </button>
        </li>
      `

      protocol.appendChild(protocolActions)

      this.protocols.appendChild(protocol)

      // Simulating delayed loading
      setTimeout(() => {
        this.protocolsWrapper.classList.remove('hide')
        this.protocolsLoadingMessage.classList.add('hide')
      }, 500)
    }

    buildProtocolDeleteModal(list) {
      const modal = document.createElement('div')

      modal.setAttribute('data-saved-protocol-modal', '')
      modal.setAttribute('data-saved-protocol-delete-modal', list.lid)
      modal.classList.add('saved-protocol-modal')
      modal.classList.add('saved-protocol-modal--delete')

      modal.innerHTML = `
        <div class="saved-protocol-modal__overlay" data-saved-protocol-modal-close></div>
        <div class="saved-protocol-modal__container">
          <button class="saved-protocol-modal__close" type="button" data-saved-protocol-modal-close>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6.5L6 18.5M6 6.5L18 18.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <p class="saved-protocol-modal__title bold">
            ${window.protocolsData.language.delete} “${list.lname}”?
          </p>
          <p class="saved-protocol-modal__message">
            ${window.protocolsData.language.thisCannotBeUndone}
          </p>
          <div class="saved-protocol-modal__actions">
            <button class="button button--secondary button--outline button--xl" type="button" data-saved-protocol-modal-close>
              ${window.protocolsData.language.cancel}
            </button>
            <button class="button button--xl" type="button" aria-label="${window.protocolsData.language.delete}: ${list.lname}" data-saved-protocol-delete="${list.lid}">
              ${window.protocolsData.language.delete}
            </button>
          </div>
        </div>
      `

      this.protocolsContainer.appendChild(modal)
    }

    buildProtocolRenameModal(list) {
      const modal = document.createElement('div')

      modal.setAttribute('data-saved-protocol-modal', '')
      modal.setAttribute('data-saved-protocol-rename-modal', list.lid)
      modal.classList.add('saved-protocol-modal')
      modal.classList.add('saved-protocol-modal--rename')

      if (list.hasOwnProperty('lprops')) {
        modal.setAttribute('data-saved-protocol-modal-lprops', JSON.stringify(list.lprops))
      }

      modal.innerHTML = `
        <div class="saved-protocol-modal__overlay" data-saved-protocol-modal-close></div>
        <div class="saved-protocol-modal__container">
          <button class="saved-protocol-modal__close" type="button" data-saved-protocol-modal-close>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6.5L6 18.5M6 6.5L18 18.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <p class="saved-protocol-modal__title bold">
            ${window.protocolsData.language.renameProtocolConfirmation}
          </p>
          <p class="saved-protocol-modal__message">
            ${window.protocolsData.language.renameProtocolMessage}
          </p>
          <div class="hidden saved-protocol-modal__error-banner banner banner--error" data-saved-protocol-error>
            <p class="saved-protocol-modal__error">
              ${window.protocolsData.language.renameProtocolError}
            </p>
          </div>
          <input id="saved-protocol-rename-${list.lid}" name="name" placeholder="${window.protocolsData.language.renameProtocolPlaceholder}" type="text" class="input saved-protocol-modal__input" value="" data-saved-protocol-rename-input>
          <div class="saved-protocol-modal__actions">
            <button class="button button--secondary button--outline button--xl" type="button" data-saved-protocol-modal-close>
              ${window.protocolsData.language.cancel}
            </button>
            <button class="button button--xl" type="button" aria-label="${window.protocolsData.language.rename}: ${list.lname}" data-saved-protocol-rename="${list.lid}">
              ${window.protocolsData.language.rename}
            </button>
          </div>
        </div>
      `

      this.protocolsContainer.appendChild(modal)
    }

    deleteEmptyList(list) {
      _swat.deleteList(list.lid)
    }

    backToProtocols(event) {
      if (!event.target.hasAttribute('data-back-to-saved-protocols')) { return }
      const listItems = this.querySelectorAll('[data-saved-protocols-list-item-wrapper]')

      window.removeTrapFocus()
      this.protocols.classList.add('hide')
      this.protocolsList.classList.remove('hide')
      this.protocolsSearch?.classList.remove('hide')
      if (this.hasAttribute('data-hide-sections')) {
        this.allOtherSections.forEach((section) => section.classList.remove('hide'))
      }
      setTimeout(() => listItems[0]?.querySelector('[data-saved-protocols-list-item]')?.focus(), 100)
    }

    showProtocol(event) {
      if (!event.target.hasAttribute('data-saved-protocols-list-item')) { return }

      const id = event.target.getAttribute('data-lid')
      const individualProtocols = this.querySelectorAll('[data-saved-protocol]')

      individualProtocols.forEach((individualProtocol) => {
        if (individualProtocol.getAttribute('data-lid') === id) {
          individualProtocol.classList.remove('hide')

          setTimeout(() => {
            window.trapFocus(individualProtocol)
          }, 200)
        } else {
          individualProtocol.classList.add('hide')
        }
      })

      this.protocols.classList.remove('hide')
      this.protocolsList.classList.add('hide')
      this.protocolsSearch?.classList.add('hide')
      if (this.hasAttribute('data-hide-sections')) {
        this.allOtherSections.forEach((section) => section.classList.add('hide'))
      }
    }

    openDeleteProtocolModal(event) {
      if (!event.target.hasAttribute('data-saved-protocol-list-item-delete')) { return }

      const protocolDeleteModal = this.querySelector(`[data-saved-protocol-delete-modal="${event.target.getAttribute('data-saved-protocol-list-item-delete')}"]`)

      protocolDeleteModal.classList.add('active')
      window.trapFocus(protocolDeleteModal)
      document.body.style.overflow = 'hidden'
    }

    openRenameProtocolModal(event) {
      if (!event.target.hasAttribute('data-saved-protocol-list-item-rename')) { return }

      const protocolRenameModal = this.querySelector(`[data-saved-protocol-rename-modal="${event.target.getAttribute('data-saved-protocol-list-item-rename')}"]`)

      protocolRenameModal.classList.add('active')
      window.trapFocus(protocolRenameModal)
      document.body.style.overflow = 'hidden'
    }

    closeProtocolModal(event) {
      if (!event.target.hasAttribute('data-saved-protocol-modal-close')) { return }
      const modals = this.querySelectorAll('[data-saved-protocol-modal]')
      modals.forEach(modal => {
        modal.classList.remove('active')
      })
      window.removeTrapFocus();
      document.body.style.overflow = 'auto'
    }

    deleteProtocol(event) {
      if (!event.target.hasAttribute('data-saved-protocol-delete')) { return }

      _swat.deleteList(event.target.getAttribute('data-saved-protocol-delete'), () => {
        window.location.reload()
      })
    }

    renameProtocol(event) {
      if (!event.target.hasAttribute('data-saved-protocol-rename')) { return }

      const modal = event.target.closest('[data-saved-protocol-rename-modal]')
      const listId = modal.getAttribute('data-saved-protocol-rename-modal')
      const lprops = modal.getAttribute('data-saved-protocol-modal-lprops')
      const input = modal.querySelector('[data-saved-protocol-rename-input]')
      const errorMessage = modal.querySelector('[data-saved-protocol-error]')
      errorMessage.classList.add('hidden')

      const config = {
        "lid": listId,
        "lname": input.value
      }

      if (lprops !== null) {
        config.lprops = JSON.parse(lprops)
      }

      const onSuccess = () => {
        const email = config.lprops['Email Address'];
        window.location.href = `${window.location.href}?client=${email}`
      }

      const onError = (error) => {
        console.error(error)
        errorMessage.classList.remove('hidden')
      }

      if (input.value) {
        _swat.updateList(config, onSuccess, onError)
      } else {
        onError(`${window.protocolsData.language.renameProtocolPlaceholder} field is required`)
      }
    }

    adjustQuantity(event) {
      if (!event.target.hasAttribute('data-saved-protocol-quantity')) { return }

      const lid = event.target.getAttribute('data-lid')
      const product = {
        epi: event.target.getAttribute('data-epi'),
        empi: event.target.getAttribute('data-empi'),
        du: event.target.getAttribute('data-du'),
        qty: parseInt(event.target.value, 10)
      }

      _swat.updateListItem(lid, product, this.updateProduct(event, lid),() => {console.log('error')})
    }

    updateProduct(event, lid) {
      const protocolProduct = event.target.closest('[data-saved-protocol-product]')
      const newLinePrice = (parseInt(event.target.getAttribute('data-price'), 10) * parseInt(event.target.value, 10)) * 100

      protocolProduct.querySelector('[data-saved-protocol-product-price]').innerHTML = Shopify.formatMoney(newLinePrice, window.themeVariables.settings.moneyFormat).replace('.00', '')
      protocolProduct.querySelector('[data-saved-product-quantity-display]').innerHTML = `${parseInt(event.target.value, 10)}x`

      this.updateListTotals(lid)
    }

    removeProduct(event) {
      if (!event.target.hasAttribute('data-saved-protocol-product-remove')) { return }

      const lid = event.target.getAttribute('data-lid')
      const product = {
        epi: event.target.getAttribute('data-epi'),
        empi: event.target.getAttribute('data-empi'),
        du: event.target.getAttribute('data-du')
      }

      _swat.deleteFromList(lid, product, this.deleteProduct(event, lid))
    }

    deleteProduct(event, lid) {
      const protocol = event.target.closest('[data-saved-protocol]')
      const product = event.target.closest('[data-saved-protocol-product]')
      const siblings = protocol.querySelectorAll('[data-saved-protocol-product]')

      if (siblings.length === 1) {
        window.location.href = '/pages/saved-protocols'
      } else {
        product.remove()
        this.updateListTotals(lid)
      }
    }

    updateListTotals(lid) {
      const protocolTotals = this.querySelectorAll(`[data-total-lid="${lid}"]`)

      for (const protocolTotal of protocolTotals) {
        const updateListTotalValues = async function (lists) {
          const matchingList = lists.find(list => list.lid === lid)
          const listTotalPrice = matchingList.listcontents.map(item => (item.pr * (item.qty === undefined ? 1 : item.qty))).reduce((a, b) => a + b, 0).toFixed(2)
          const retailListTotalPrice = matchingList.listcontents.filter(item => item.cprops?.type === 'retail').map(item => (item.pr * (item.qty === undefined ? 1 : item.qty))).reduce((a, b) => a + b, 0).toFixed(2)

          protocolTotal.setAttribute('data-saved-protocol-total', protocolTotal.hasAttribute('data-saved-protocol-retail-total') ? retailListTotalPrice : listTotalPrice)
          protocolTotal.innerHTML = Shopify.formatMoney(protocolTotal.hasAttribute('data-saved-protocol-retail-total') ? retailListTotalPrice : listTotalPrice, window.themeVariables.settings.moneyFormat)

          if (retailListTotalPrice <= 0) {
            protocolTotal.closest('[data-saved-protocol]').querySelector('[data-saved-protocols-category="retail"]').classList.add('hide')
            protocolTotal.closest('[data-saved-protocol]').querySelector('[data-saved-protocol-subtotal-retail]').classList.add('hide')
          }
        }

        setTimeout(() => {
          _swat.fetchLists({
            callbackFn: updateListTotalValues
          })
        }, 250)
      }
    }

    async addToCart(event) {
      if (!event.target.hasAttribute('data-saved-protocol-add-to-cart')) { return }

      event.target.setAttribute("disabled","disabled");
      event.target.querySelector("span").innerText = "Adding...";

      const cartSubmission = {
        attributes: {},
        items: []
      }
      const protocol = event.target.closest('[data-saved-protocol]')
      const products = protocol.querySelectorAll('[data-saved-protocol-product]')
      const cartAttributes = protocol.querySelectorAll('[data-saved-protocol-cart-attribute-key]')
      const lineProperties = protocol.querySelectorAll('[data-saved-protocol-line-property-key]')
      const editButtonLink = protocol.querySelector('[data-saved-protocol-list-item-edit]');
      let hasMainProduct = false

      const productData = Array.from(products).map((product) => {
        return {
          title: product.getAttribute('data-product-title'),
          handle: product.getAttribute('data-product-handle'),
          variantId: product.getAttribute('data-variant-id')
        }
      });

      const soldoutItems = await window.checkInventoryLevels(productData, editButtonLink);

      if (soldoutItems && soldoutItems.length) { 
        event.target.removeAttribute("disabled");
        event.target.querySelector("span").innerText = "Add to cart";
        return; 
      }

      const timestamp = Date.now();

      products.forEach((product) => {
        if (product.getAttribute('data-product-type') !== 'main') { return }
        hasMainProduct = true
      })

      products.forEach((product, index) => {
        const productType = (!hasMainProduct && index === 0) ? 'main' : product.getAttribute('data-product-type')
        const properties = {
          '_type':  productType,
          '_protocol': timestamp,
          '_quantity': product.querySelector('[data-saved-protocol-quantity]')?.value || 1
        }

        if (productType === 'main')  {
          lineProperties.forEach((attribute) => {
            const key = attribute.getAttribute('data-saved-protocol-line-property-key')
            properties[key] = attribute.getAttribute('data-saved-protocol-line-property-value')
          })

          cartAttributes.forEach((attribute) => {
            const key = attribute.getAttribute('data-saved-protocol-cart-attribute-key')
            properties[key] = attribute.getAttribute('data-saved-protocol-cart-attribute-value')
          })
        }

        const productObject = {
          id: product.getAttribute('data-variant-id'),
          quantity: product.querySelector('[data-saved-protocol-quantity]') === null ? 1 : product.querySelector('[data-saved-protocol-quantity]').value,
          properties
        }

        cartSubmission.items.push(productObject)
      })

      cartAttributes.forEach((attribute) => {
        const key = attribute.getAttribute('data-saved-protocol-cart-attribute-key')
        cartSubmission.attributes[key] = attribute.getAttribute('data-saved-protocol-cart-attribute-value')
      })

      // Reverse product array so base product shows first in protocol within the checkout
      cartSubmission.items.reverse()

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify(cartSubmission)
      }).then((response) => {
        return response.json()
      }).then((result) => {
        if (result.status) {
          throw new Error(result.description)
        }

        window.location.href = window.protocolsData.routes.cart

        return null
      }).catch((error) => {
        alert(error)
      })
    }
  }

  window.customElements.define('saved-protocols', SavedProtocols);
}

function openIngredientsDropdown(target){
  target.classList.toggle("acive");
}